export default {"src":"/_next/static/media/helpline-icon.30faa8ae.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};